module.exports = __webpack_public_path__ + "img/topic2.5afd60af.png";